<template>
  <el-dialog
    @closed="gaunbi"
    title="添加达人"
    :visible.sync="dialogVisible"
    width="40%"
    :close-on-click-modal="false"
  >
    <div class="title">提示：新增达人信息提交后，将进行审核。</div>

    <el-steps :active="active" finish-status="success">
      <el-step title="步骤 1"></el-step>
      <el-step title="步骤 2"></el-step>
    </el-steps>

    <div v-if="show">
      <el-form
        ref="form2"
        style="width: 85%"
        :rules="rules2"
        :model="add"
        label-width="120px"
      >
        <el-form-item label="微信号" prop="weixinid">
          <el-input v-model="add.weixinid"></el-input>
        </el-form-item>
        <el-form-item label="收货人" prop="post_name">
          <el-input v-model="add.post_name"></el-input>
        </el-form-item>
        <el-form-item label="收货电话" prop="post_telephone">
          <el-input v-model="add.post_telephone"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="post_address">
          <el-input v-model="add.post_address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goback">上一步</el-button>
        <el-button type="primary" @click="addexpertsanalyse">确定</el-button>
      </span>
    </div>

    <div v-if="!show">
      <el-form
        ref="form1"
        style="width: 85%"
        :rules="rules1"
        :model="add"
        label-width="120px"
      >
        <el-form-item label="来源平台">
          <el-radio-group v-model="add.platform">
            <el-radio-button label="抖音"  ></el-radio-button>
            <el-radio-button label="快手"  ></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="达人主页链接" prop="home_url">
          <el-input
            placeholder="请输入内容"
            v-model="add.home_url"
            class="input-with-select"
          >
            <el-button slot="append" @click="expertsanalyse">解析</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <el-form
        ref="form"
        style="width: 85%"
        :rules="rules"
        :model="add"
        label-width="120px"
      >
        <div class="peolpe_info">
          <div class="block">
            <el-avatar :size="80" :src="add.avatar"></el-avatar>
          </div>
          <div>
            <div>{{ add.nickname }}</div>
            <div>ID:{{ add.unique_id }}</div>
          </div>
        </div>
        <el-form-item label="总销量" prop="shop_sales">
          <el-input
            style="width: 25%"
            v-model.number="add.shop_sales"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="4" v-model="add.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="next()">下一步</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
import { Analyseone, Experts, ExpertsAll } from '../../api/api2'
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    var validatorFenshu = function (rule, value, callback) {
      if (value != '') {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error('请填写大于0的数字'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      rules: {
        shop_sales: [
          { required: true, validator: validatorFenshu, trigger: 'blur' },
        ],
      },
      rules1: {
        home_url: [
          { required: true, message: '请输入解析的内容', trigger: 'blur' },
        ],
      },
      rules2: {
        weixinid: [
          { required: true, message: '请输入解析的内容', trigger: 'blur' },
        ],
        post_name: [
          { required: true, message: '请输入解析的内容', trigger: 'blur' },
        ],
        post_telephone: [
          { required: true, validator: validatorPhone, trigger: 'blur' },
        ],
        post_address: [
          { required: true, message: '请输入解析的内容', trigger: 'blur' },
        ],
      },

      dialogVisible: false,
      active: 0,
      show: false,
      add: {
        nickname: '',
        avatar: '',
        platform: '抖音',
        home_url: '',
        unique_id: '',
        shop_sales: '',
        remark: '',
        weixinid: '',
        post_name: '',
        post_telephone: '',
        post_address: '',
      },
    }
  },
  methods: {
    getAll() {
      let params = new URLSearchParams()

      params.append('page', 1)

      ExpertsAll(params)
        .then((res) => {
          this.tableData = res.data.data
          this.total = res.data.total
        })
        .catch((error) => {
          if (error.response.status == '422') {
            this.$message.error('获取失败')
          }
        })
    },
    //关闭窗口清除数据
    gaunbi() {
      this.active = 0
      this.show = false
      this.add.name = ''
      this.add.unique_id = ''
      this.add.nickname = ''
      this.add.avatar = ''
      this.add.shop_sales = ''
      this.add.remark = ' '
      this.add.home_url = ''
      this.add.post_name = ''
      this.add.post_telephone = ' '
      this.add.post_address = ''
      this.add.weixinid = ''
    },
    addexpertsanalyse() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          let platform
          if (this.add.platform == '抖音') {
            platform = 'douyin'
          } else {
            platform = 'kuaishou'
          }
          let params = new URLSearchParams()
          params.append('platform', platform)
          params.append('home_url', this.add.home_url)
          params.append('unique_id', this.add.unique_id)
          params.append('avatar', this.add.avatar)
          params.append('shop_sales', this.add.shop_sales)
          params.append('remark', this.add.remark)
          params.append('nickname', this.add.nickname)
          params.append('weixinid', this.add.weixinid)
          params.append('post_name', this.add.post_name)
          params.append('post_telephone', this.add.post_telephone)
          params.append('post_address', this.add.post_address)
          Experts(params)
            .then((res) => {
              this.active = 2
              this.$message.success('添加达人成功')
              this.dialogVisible = false
            })
            .catch((error) => {
              if (error.response.status == '422') {
                // this.$message.error(error.response.data.errors.unique_id[0]);
                this.$message.error('达人信息已存在')
                this.dialogVisible = false
              } else {
                this.$message.error('操作失败')
              }
            })
        }
      })
    },
    goback() {
      this.active = 0
      this.show = false
    },
    //下一步
    next() {
      if (this.add.avatar != '') {
        this.active = 1
        this.show = true
      } else {
        this.$message.error('请先解析达人链接')
      }
    },
    // 解析达人
    expertsanalyse() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          let platform
          if (this.add.platform == '抖音') {
            platform = 'douyin'
          } else {
            platform = 'kuaishou'
          }
          let params = new URLSearchParams()
          params.append('platform', platform)
          params.append('url', this.add.home_url)
          Analyseone(params)
            .then((res) => {
              this.add.nickname = res.data.nickname
              this.add.avatar = res.data.avatar
              this.add.unique_id = res.data.unique_id
              this.$message.success('解析达人成功')
            })
            .catch((error) => {
              if (error.response.status == '422') {
                this.$message.error(error.response.data.message)
              } else {
                this.$message.error('操作失败')
              }
            })
        }
      })
    },
    openbox() {
      this.dialogVisible = true
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #229fa0;
    border-color: #229fa0;
    -webkit-box-shadow: -1px 0 0 0 #229fa0;
    box-shadow: -1px 0 0 0 #229fa0;
}
.title {
  padding: 8px;

  color: rgb(238, 240, 224);
  background-color: #229fa0;
}
.peolpe_info {
  display: flex;
  align-items: center;

  margin-left: 100px;
  div {
    margin: 10px;
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.el-steps {
  width: 50%;
  margin: 0 auto;
  padding: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/view/balance/AddBox.vue